import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { post, put, get } from '../../axios/apiService';
import toast from 'react-hot-toast';
import uploadFilesService from '../../axios/uploadFilesService';
import DocumentUploader from 'ui-component/uploadDocument';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFileNameFromUrl } from 'utils/urlToGetFileName';
import { addPercentage, isEmpty, isValidDate, validateAmount, validateEmail } from 'utils/validator';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Stack, styled } from '@mui/system';
import NomineeDetails from 'ui-component/nomineeDetail';
import { generateUniqueId } from 'utils/commonfunction';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';

const ResizableTextField = styled(TextField)({
  '& .MuiInputBase-inputMultiline': {
    resize: 'both',
    overflow: 'auto',
  },
});

function AddEditInvestmentsForm({ id, setIsShowForm, customerId }) {
  const [typeValues, setTypeValues] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [existingDoc, setExistingDoc] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [usedInvestmentNominees, setUsedInvestmentNominees] = useState([]);
  const [isValidationNominee, setIsValidationNominee] = useState(false);
  const [isValidation, setIsValidation] = useState(false);

  const[isLoading,setIsLoading] = useState(false);
  const { control, handleSubmit, setValue, getValues,watch } = useForm({
    defaultValues: {
      Type: 0,
      Platform: '',
      BankOrCompanyName: '',
      AccountNumber: '',
      CustomerId: '',
      IFSC: '',
      MonthlySipAmount: 0,
      RateOfInterest: 0,
      MaturityDate: '',
      InvestedTotal: 0,
      IssueReference: 0,
      Units: 0,
      IssuePrice: 0,
      Email: '',
      InvestmentDocuments: null
    }
  });

  const watchedFields = [
    'Platform',
    'Type',
    'BankOrCompanyName',
    'AccountNumber',
    'CustomerId',
    'IFSC',
    'MonthlySipAmount',
    'RateOfInterest',
    'MaturityDate',
    'InvestedTotal',
    'IssueReference',
    'Units',
    'IssuePrice',
    'Email'
  ];

  const {
    control: nomineesControl,
    getValues: nomineesGetValues,
    reset: nomineesReset,
    watch: nomineesWatch
  } = useForm({
    defaultValues: {
      address: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  });

  
  const formValues = useMemo(() =>
    watchedFields.reduce((acc, field) => {
      acc[field] = watch(field);
      return acc;
    }, {}),
    watchedFields.map(watch)
  );

  useEffect(() => {
    if (isValidation) {
      validator(formValues);
    }
  }, [formValues, isValidation]);

  useEffect(() => {
    if (isValidationNominee) {
      const formNomineesData = {
        firstName: nomineesWatch("firstName"),
        lastName: nomineesWatch("lastName"),
        address: nomineesWatch("address"),
        phone: nomineesWatch("phone"),
        allocationPercentage: nomineesWatch("allocationPercentage"),
      };
      validateNominees(formNomineesData);
    }
  }, [isValidationNominee, nomineesWatch("firstName"), nomineesWatch("lastName"), nomineesWatch("address"), nomineesWatch("phone"), nomineesWatch("allocationPercentage")]);

  useEffect(() => {
    const fetchInvestmentsById = async (editId) => {
      try {
        let response = await get(`Investments/${editId}`);
        if (response) {
          setValue('Type', response?.type);
          setValue('Platform', response?.platform);
          setValue('BankOrCompanyName', response?.bankOrCompanyName);
          setValue('AccountNumber', response?.accountNumber);
          setValue('CustomerId', response?.customerId);
          setValue('IFSC', response?.ifsc);
          setValue('MonthlySipAmount', response?.monthlySipAmount);
          setValue('RateOfInterest', response?.rateOfInterest);
          setValue('MaturityDate', response?.maturityDate ? new Date(response?.maturityDate).toLocaleDateString('en-CA') : '');
          setValue('InvestedTotal', response?.investedTotal);
          setValue('IssueReference', response?.issueReference);
          setValue('Units', response?.units);
          setValue('IssuePrice', response?.issuePrice);
          setValue('Email', response?.email);
          setValue('InvestmentDocuments', response?.investmentDocuments);
          setExistingDoc(response?.investmentDocuments);
          setUsedInvestmentNominees(response.investmentNominees);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    const fetchTypes = async () => {
      try {
        let response = await get(`WillTypeMaster/Investments`);
        setTypeValues(response);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchTypes();

    if (id) {
      fetchInvestmentsById(id);
    }
  }, [id]);


  const onSubmit = async (data) => {
    // data.InvestmentDocumentsBlobUrl = [];
    setIsValidation(true);
    if (!validator()) return;
    let uploadFileList = await uploadDocBlob();
    let investmentDocuments =
      uploadFileList?.map((x) => ({
        blobUrl: x.fileName,
        fileName: documentList[x.fileId - 1].name
      })) || [];
    // if (!id && investmentDocuments.length === 0) {
    //   toast.error('please upload document');
    //   return;
    // }

    if (!customerId) {
      toast.error('Please select customer');
      return;
    }

    if (usedInvestmentNominees.length == 0) {
      toast.error("Please add at least one nominee");
      return;
    }
    let allocationTotal = 0;
    usedInvestmentNominees.forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
    if (allocationTotal != 100) {
      toast.error("Allocation of all nominee(s) must be 100%");
      return;
    }


    data.InvestmentDocuments = investmentDocuments;
    data.CustomerId = customerId;

    if (id) {
      data.id = id;
      // let existingFileName = existingDoc.map(x => { return { blobUrl: x.fileName } });
      let existingFileName = existingDoc?.map((x) => {
        let urlName = getFileNameFromUrl(x.blobUrl);
        return { ...x, blobUrl: urlName };
      });

      data.InvestmentDocuments = [...investmentDocuments, ...existingFileName];

      // if (data?.InvestmentDocuments?.length === 0) {
      //   toast.error('please upload document');
      //   return;
      // }
    }

    let param = { ...data };
    param.investmentNominees = usedInvestmentNominees;

    let response = id ? await put(`Investments/${id}`, param) : await post(`Investments`, param);
    if (response) {
      toast.success(id ? 'Investments updated successfully' : 'Investments added successfully');
    }
    setIsShowForm(false);
    setIsValidation(false);
  };
  const validator = () => {
    let data = getValues();
    const errors = {};
    if (isEmpty(data?.Platform)) {
      errors.platform = 'Please Enter Platform';
    }
    if (isEmpty(data?.BankOrCompanyName)) {
      errors.bankOrCompanyName = 'Please Enter BankOrCompanyName';
    }
    if (isEmpty(data?.AccountNumber)) {
      errors.accountNumber = 'Please Enter AccountNumber';
    }
    if (isEmpty(data?.IFSC)) {
      errors.ifsc = 'Please Enter IFSC';
    }

    if (isEmpty(data?.Email)) {
      errors.email = 'Please Enter email-id';
    } else if (!isEmpty(data?.Email) && !validateEmail(data.Email)) {
      errors.email = 'Please Enter a valid email';
    } else {
      delete errors.email;
    }

    if (!validateAmount(data?.MonthlySipAmount, 1)) {
      errors.monthlySipAmount = "Please enter a valid MonthlySipAmount greater than or equal to 1.";
    }

    if (!validateAmount(data?.RateOfInterest, 1)) {
      errors.rateOfInterest = "Please enter a valid RateOfInterest greater than or equal to 1.";
    }

    if (!validateAmount(data?.InvestedTotal, 1)) {
      errors.investedTotal = "Please enter a valid InvestedTotal greater than or equal to 1.";
    }


    if (!validateAmount(data?.IssueReference, 1)) {
      errors.issueReference = "Please enter a valid IssueReference greater than or equal to 1.";
    }

    if (!validateAmount(data?.Units, 1)) {
      errors.units = "Please enter a valid Units greater than or equal to 1.";
    }

    if (!validateAmount(data?.IssuePrice, 1)) {
      errors.issuePrice = "Please enter a valid IssuePrice greater than or equal to 1.";
    }

    if (!isValidDate(data?.MaturityDate)) {
      errors.maturityDate = 'Please Enter MaturityDate';
    }
    if (!validateAmount(data?.Type, 1)) {
      errors.type = "Please select type";
    }


    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateNominees = (nomineesData) => {
    const errors = {};

    if (isEmpty(nomineesData?.firstName)) {
      errors.firstName = "Please Enter First Name";
    }

    if (isEmpty(nomineesData?.lastName)) {
      errors.lastName = "Please Enter Last Name";
    }

    let mobileNumber = nomineesData?.phone && nomineesData?.phone.startsWith('+') ? nomineesData?.phone : `+${nomineesData?.phone}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);

    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Invalid Phone Number";
    }

    if (isEmpty(nomineesData?.address)) {
      errors.address = "Please Enter Address";
    }

    if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }
    if (!isNaN(nomineesData?.allocationPercentage) && !addPercentage(nomineesData?.allocationPercentage, usedInvestmentNominees)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveNominees = () => {
    let nomineesData = {
      firstName: nomineesGetValues("firstName"),
      lastName: nomineesGetValues("lastName"),
      address: nomineesGetValues("address"),
      phone: nomineesGetValues("phone"),
      id: generateUniqueId(),
      allocationPercentage: nomineesGetValues("allocationPercentage"),
    };
    setIsValidationNominee(true);
    if (!validateNominees(nomineesData)) return;
    setIsValidationNominee(false);

    try {
      setIsLoading(true);
      let newNominees = usedInvestmentNominees;
      newNominees = [...newNominees, ...[nomineesData]];
      setUsedInvestmentNominees(newNominees);
      nomineesReset({
        address: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        allocationPercentage: 0,
      });
    } catch (error) {
      console.log("error....", error)
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsShowForm(false);
  };

  const columns = [
    { field: "firstName", headerName: "First Name", flex: 1 },
    { field: "lastName", headerName: "Last Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "allocationPercentage", headerName: "Allocation Percentage", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      renderCell: (params) => <ActionButtons {...params.row} />,
      // align: 'right',
      width: 200,
      sortable: false,
      filterable: false,
    },
  ];

  const ActionButtons = (row) => {
    return (
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent="center"
        sx={{ marginTop: "10px" }}
      >
         <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={() => {
            handleNomineeEdit(row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            setUsedInvestmentNominees((prevItems) => prevItems.filter((item) => item.id != row.id));
          }}
        >
          Delete
        </Button>
      </Stack>
    );
  };
  const handleNomineeEdit = (nomineeId) => {
    let existingNominee = usedInvestmentNominees.filter((x) => x.id == nomineeId);
    const updatedNominees = usedInvestmentNominees.filter((nominee) => nominee.id !== nomineeId);
    setUsedInvestmentNominees(updatedNominees);
    if (existingNominee && existingNominee[0]) {
      nomineesReset({
        address: existingNominee[0].address,
        allocationPercentage: existingNominee[0].allocationPercentage,
        firstName: existingNominee[0].firstName,
        lastName: existingNominee[0].lastName,
        phone: existingNominee[0].phone,
        id: existingNominee[0].id,
      });
    }
  };

  const uploadDocBlob = async (data) => {
    const formData = new FormData();
    for (let i = 0; i < documentList.length; i++) {
      formData.append('files', documentList[i]);
      formData.append('fileIds', i + 1);
    }
    formData.append('categoryId', 4);
    try {
      let data = await uploadFilesService(formData);
      return data;
    } catch (error) {
      console.error('There was an error uploading the files!', error);
    }
  };

  const handleUpload = (newFiles) => {
    setDocumentList((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemove = (index) => {
    setDocumentList((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const handleRemoveExistDoc = (index) => {
    setExistingDoc((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };

  return (
    // <MainCard title="Insurance Form">
    <>
      <Box sx={{ padding: '30px 0' }}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => setIsShowForm(false)} startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </Box>
        </Grid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>Investment Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Type</InputLabel>
                  <Controller
                    name="Type"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select labelId="type-label" label="Type" {...field}>
                          {typeValues &&
                            typeValues.map((x, i) => (
                              <MenuItem value={x.id} key={i}>
                                {x.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </>
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.type}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="Platform" control={control} render={({ field }) => <TextField {...field} label="Platform" />} />
                  <div style={{ color: 'red' }}>{formErrors.platform}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="BankOrCompanyName"
                    control={control}
                    render={({ field }) => <TextField {...field} label="Bank Or Company Name" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.bankOrCompanyName}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="AccountNumber"
                    control={control}
                    render={({ field }) => <TextField {...field} label="Account Number" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.accountNumber}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="IFSC" control={control} render={({ field }) => <TextField {...field} label="IFSC" />} />
                  <div style={{ color: 'red' }}>{formErrors.ifsc}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="MonthlySipAmount"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Monthly Sip Amount" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.monthlySipAmount}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="RateOfInterest"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Rate Of Interest" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.rateOfInterest}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="MaturityDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="maturity-date"
                        InputLabelProps={{
                          shrink: true // This will keep the label "sticky"
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="Maturity Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.maturityDate}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="InvestedTotal"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Invested Total" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.investedTotal}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="IssueReference"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Issue Reference" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.issueReference}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="Units" control={control} render={({ field }) => <TextField {...field} type="number" label="Units" />} />
                  <div style={{ color: 'red' }}>{formErrors.units}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="IssuePrice"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Issue Price" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.issuePrice}</div>

                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="Email" control={control} render={({ field }) => <TextField {...field} label="Email" />} />
                  <div style={{ color: 'red' }}>{formErrors.email}</div>

                </FormControl>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
                Submit
              </Button>
              <Button type="button" variant="contained" color="error" className="mt-4" onClick={handleCancel}>
                Cancel
              </Button>
            </Grid> */}
            </Grid>
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Document Information</legend>
            <DocumentUploader
              onUpload={handleUpload}
              documentList={documentList}
              onRemove={handleRemove}
              onRemoveExistDoc={handleRemoveExistDoc}
              existDocumentList={existingDoc}
            />
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Nominee Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="firstName" control={nomineesControl} render={({ field }) => <TextField {...field} label="First Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="lastName" control={nomineesControl} render={({ field }) => <TextField {...field} label="Last Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="phone" control={nomineesControl} render={({ field }) =>
                    <PhoneInput
                      {...field}
                      country={'in'}
                      onChange={(value) => field.onChange(value)}
                      inputStyle={{ width: '100%' }}
                    />

                  } />

                  <div style={{ color: 'red' }}>{formErrors.phone}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="address" control={nomineesControl} render={({ field }) =>
                    <ResizableTextField
                      {...field}
                      label="Address"
                      multiline
                      rows={4} // Specifies initial number of rows
                    />
                  } />
                  <div style={{ color: 'red' }}>{formErrors.address}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                <Controller
                    name="allocationPercentage"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="AllocationPercentage" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.allocationPercentage}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button" 
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                    onClick={saveNominees}
                  >
                    Save Nominee
                  </Button>
                </Box>
              </Grid>
              {usedInvestmentNominees && usedInvestmentNominees.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
                  <NomineeDetails nominees={usedInvestmentNominees} columns={columns} />
                </Grid>
              )}
            </Grid>
          </fieldset>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
            <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
              Submit
            </Button>
            <Button
              type="button"
              variant="contained"
              color="error"
              className="mt-4"
              onClick={() => {
                setIsShowForm(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
        </form>
        <LoadingBackdrop open={isLoading} />
      </Box>
    </>
    // </MainCard>
  );
}

export default AddEditInvestmentsForm;
const styles = {
  fieldset: {
    border: '1px solid #364152',
    borderRadius: '8px',
    padding: '20px'
  },
  legend: {
    color: '#364152',
    padding: '0 10px',
    fontSize: '18px'
  }
};
